// Copyright (c) 2017 Deere & Company

import '../../shared/styles/index.scss';
import './index.scss';
import React, {Component, PropTypes} from 'react';
import {
    bindOnConfirmActions,
    confirmationModalMap
} from '../services/confirmation-modal-map';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import ClaimStickyHeader from '../../shared/components/claim-sticky-header';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import ConfirmationModalState from '../../shared/state/confirmation-modal';
import CreateClaimModal from '../../../shared/components/create-claim-modal';
import CreateClaimModalType from '../../../shared/state/create-claim-modal';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import FullDetails from './full-details';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import SpaClaim from '@deere/cps-it.warranty-model-factory/lib/claim-special-allowance';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import WarrantyStatusModal from '../../../shared/components/warranty-status-modal';
import WarrantyStatusModalState from '../../../claim/shared/state/warranty-status-modal';
import WarrantyStickyNode from '../../../shared/components/warranty-sticky-node';
import {closeActiveWarrantyClaimModal} from '../../../claim/shared/services/warranty-modal-actions';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';
import {generateTemporaryObjectKey} from '../../../shared/services/generate-temporary-object-key';

function handleActionClick(action) {

    const onConfirmActions = bindOnConfirmActions(action, this.claim, {
        addRep: this.actions.additionalRepair,
        adjust: this.actions.updateSelectedAction,
        copy: this.actions.copyClaim,
        delete: this.actions.updateSelectedAction,
        pushxml: this.actions.updateSelectedAction,
        reconcile: this.actions.updateSelectedAction,
        unreconcile: this.actions.updateSelectedAction,
        unsubmit: this.actions.updateSelectedAction
    });

    const actionMethod = confirmationModalMap(action, this.actions.resetConfirmationModal, onConfirmActions);

    actionMethod ?
        this.actions.setConfirmationModal(actionMethod) :
        this.actions.updateSelectedAction(action);

}

function readClaimIfEdit() {

    if (this.props.routeParams.claimNumber && !this.props.queryParams.action) {

        this.props.actions.readSpaClaim(this.props.routeParams.claimNumber);
        this.props.actions.updateIsEditable(false);

    }

}

function handleClaimAction() {

    if (this.props.queryParams.action) {

        const action = new ClaimAction({
            actionName: this.props.queryParams.action,
            id: this.props.queryParams.action,
            mode: ''
        });

        this.props.actions.readSpaClaim(this.props.routeParams.claimNumber, action);

        if (['DIS_VSR', 'RECONCILE', 'UNRECONCIL', 'DEL', 'REQ_ADDL', 'UNSUB', 'PUSH_XML'].includes(this.props.queryParams.action)) {

            this.props.actions.updateIsEditable(false);

        }

    }

}

function setPin() {

    if (this.props.routeParams.pin) {

        this.props.actions.updateSpaClaimProperty('pin', this.props.routeParams.pin);
        this.props.actions.readClaimProduct(this.props.routeParams.pin);

    }

}

function getSpaTypes() {

    if (this.props.claim.responsibleAccount.account) {

        this.props.actions.readSpaTypes(this.props.claim.responsibleAccount.account);

    }

}

function handleCreateClaimModalClose() {

    this.actions.updateCreateClaimModalVisibility(false);

}

function handleClick(key, pin) {

    if (this.createClaimModal.mode === 'CREATE') {

        this.actions.onCreateClaim(key, pin, this.claim.claimType.key);

    }

    if (this.createClaimModal.mode === 'EDIT') {

        this.actions.onEditClaim(key, pin, this.claim.claimType.key, this.claim);

    }

}

class SpaClaims extends Component {

    componentWillMount() {

        if (!this.props.tcsm) {

            this.props.actions.updateTemporaryObjectKey(generateTemporaryObjectKey());
            this.props.actions.readOwnershipStatuses();
            this.props.actions.readDownTime();
            this.props.actions.readFailureModes();
            this.props.actions.readClaimTypes();
            this.props.actions.readGoodsInstallationVatOptions();

        }

        this::readClaimIfEdit();
        this::handleClaimAction();
        this::setPin();
        this::getSpaTypes();

    }

    componentDidUpdate() {

        if (this.props.isCopied) {

            const tempObjectKey = generateTemporaryObjectKey();

            this.props.actions.updateTemporaryObjectKey(tempObjectKey);
            this.props.actions.copyAttachments(this.props.claim, tempObjectKey, 'SPA');

        }

    }

    componentWillUnmount() {

        this.props.actions.resetSpaClaim();
        this.props.actions.resetSpaProductDetails();
        this.props.actions.resetCustomerDetails();
        this.props.actions.resetCkcCustomerFailure();

    }

    render() {

        return this.props.tcsm ? (
            <section className='spa-claims'>
                <FullDetails
                    actions={this.props.actions}
                    claim={this.props.claim}
                    claimNumber={this.props.routeParams.claimNumber}
                    customer={this.props.customer}
                    isCkcCustomerFailed={this.props.isCkcCustomerFailed}
                    isEditable={this.props.isEditable}
                    latestPerUnitMeasurements={this.props.latestPerUnitMeasurements}
                    partsGroupedByPartNumber={this.props.partsGroupedByPartNumber}
                    product={this.props.product}
                    tabm={this.props.tabm}
                    tcsm={this.props.tcsm}
                />
                <WarrantyStatusModal
                    isModalOpen={this.props.warrantyStatusModal.isModalOpen}
                    onCloseButtonClick={this.props::closeActiveWarrantyClaimModal}
                    pin={this.props.product.pin}
                    warranties={this.props.warranties}
                />
            </section>

        ) : (
            <section className='spa-claims'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <WarrantyStickyNode
                    activeClass='enabled'
                    innerZ={4}
                    top='.app-header'
                >
                    <ClaimStickyHeader
                        allowedActions={this.props.claim.allowedActions}
                        claimNumber={formatClaimNumber(this.props.claim.claimNumber)}
                        claimStatus={this.props.claim.claimStatus.key}
                        creditMemoNumber={this.props.claim.specialAllowanceCalculations.creditMemoNumber}
                        errorMessages={this.props.claim.vsrErrorMessages()}
                        infoMessages={this.props.claim.vsrInfoMessages()}
                        isActionButtonDisabled={this.props.isActionButtonDisabled}
                        isEditable={this.props.isEditable}
                        onActionClick={this.props::handleActionClick}
                        warningMessages={this.props.claim.vsrWarningMessages()}
                    />
                </WarrantyStickyNode>
                <FullDetails
                    actions={this.props.actions}
                    claim={this.props.claim}
                    customer={this.props.customer}
                    isCkcCustomerFailed={this.props.isCkcCustomerFailed}
                    isEditable={this.props.isEditable}
                    latestPerUnitMeasurements={this.props.latestPerUnitMeasurements}
                    partsGroupedByPartNumber={this.props.partsGroupedByPartNumber}
                    product={this.props.product}
                    tabm={this.props.tabm}
                    tcsm={this.props.tcsm}
                    temporaryObjectKey={this.props.temporaryObjectKey}
                />
                <ConfirmationModal
                    confirmMessage={this.props.confirmationModal.confirmMessage}
                    isOpen={this.props.confirmationModal.isOpen}
                    onClose={this.props.confirmationModal.onClose}
                    onConfirm={this.props.confirmationModal.onConfirm}
                    title={this.props.confirmationModal.title}
                />
                <CreateClaimModal
                    claimTypes={this.props.createClaimModal.claimTypes}
                    isModalOpen={this.props.createClaimModal.isModalOpen}
                    onClick={this.props::handleClick}
                    onCloseButtonClick={this.props::handleCreateClaimModalClose}
                    selectedPin={this.props.product.pin}
                />
                <WarrantyStatusModal
                    isModalOpen={this.props.warrantyStatusModal.isModalOpen}
                    onCloseButtonClick={this.props::closeActiveWarrantyClaimModal}
                    pin={this.props.product.pin}
                    warranties={this.props.warranties}
                />
            </section>
        );

    }

}

SpaClaims.displayName = 'SpaClaims';
SpaClaims.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    claim: PropTypes.instanceOf(SpaClaim).isRequired,
    confirmationModal: PropTypes.instanceOf(ConfirmationModalState).isRequired,
    createClaimModal: PropTypes.instanceOf(CreateClaimModalType).isRequired,
    customer: PropTypes.instanceOf(Customer).isRequired,
    isActionButtonDisabled: PropTypes.bool.isRequired,
    isCkcCustomerFailed: PropTypes.bool.isRequired,
    isCopied: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool.isRequired,
    latestPerUnitMeasurements: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    partsGroupedByPartNumber: PropTypes.object.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    routeParams: PropTypes.object.isRequired,
    tabm: PropTypes.bool,
    tcsm: PropTypes.bool,
    temporaryObjectKey: PropTypes.string,
    warranties: PropTypes.arrayOf(PropTypes.instanceOf(Warranty)).isRequired,
    warrantyStatusModal: PropTypes.instanceOf(WarrantyStatusModalState).isRequired
};
SpaClaims.defaultProps = {
    tabm: false
};
export default SpaClaims;



// WEBPACK FOOTER //
// ./src/claim/spa/components/index.js